import paths from '@app/routes/paths';
import { SideNav } from '@servicetitan/design-system';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import React from 'react';

interface SideNavLinkProps {
  path: string;
  children: React.ReactNode;
  id: string;
}

const SideNavLink = ({ path, children, id }: SideNavLinkProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (path: string): boolean =>
    pathname === path || pathname.startsWith(`${path}/`);

  return (
    <Link onClick={() => navigate(`/${path}`)} to={path}>
      <SideNav.Item active={isActive(`/${paths.callContinuity}`)} id={id}>
        {children}
      </SideNav.Item>
    </Link>
  );
};

export default SideNavLink;
